export default "__VITE_ASSET__DAVXYzlU__"